module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_7016.9a59ceed.png";